import { $, $$ } from 'src/shared/js/utils/dom';
import Swiperslider from 'src/shared/js/modules/swiper/swiper';

const imageSliders = $$('.image-slider');

if (imageSliders.length) {
  imageSliders.forEach(slider => {
    const imageSlider = new Swiperslider($('.image-slider__wrapper', slider), {
      container: slider,
    });
    imageSlider.init();
  });
}
